<template>
  <div class="DayOverallNum">
    <p style="height: 30px;"><span @click="goBacks" class="el-icon-circle-close"
        style="float: right; font-size: 24px;"></span></p>
        <p style="font-size: 22px; font-weight: bold;">{{ ownerDate }}日课消统计</p>
    <div class="box">总课消:{{ text }}</div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed prop="ownerDate" label="日期">
      </el-table-column>
      <el-table-column prop="teacherName" label="教师姓名">
      </el-table-column>
      <el-table-column label="课节数">
        <template slot-scope="scope">
          <router-link :to="`/PersonalParticulars/${scope.row.teacherId}/${scope.row.ownerDate}/${scope.row.teacherName}`">
            {{ scope.row.classNum }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="classMoney" label="课消金额">
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  data () {
    return {
      ownerDate: "",
      total: 0,
      text: '',
      tableData: [],
      requestParameters: {
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
    }
  },
  created () {
    this.ownerDate = localStorage.getItem('ownerDate')
    this.getListData()
  },
  methods: {
    //关闭按钮
    goBacks () {
      history.go(-1)
    },
    handleSizeChange (pageSize) {
      this.requestParameters.pageSize = pageSize;
      if (this.requestParameters.page === 1) {

      }
      this.getListData(this.requestParameters);
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.pageNum = newPage;
      this.getListData();
    },
    //根据日期查找每日所有老师的课消
    getListData () {
      let data = {
        ownerDate: this.ownerDate,
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize
      }
      axios
        .post(`${apiBaseUrl}/classSales/getClassSalesDay`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          this.tableData = res.data.data.records
          this.total=res.data.data.total
          if (res.data.data.records.length > 0) {
            this.text = res.data.data.records[0].totalMoney
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
  }
}
</script>

<style scoped>
.box {
  width: 150px;
  height: 100px;
  box-shadow: 5px 5px 5px 5px #ccc;
  margin-bottom: 40px;
  text-align: left;
  line-height: 100px;
  border-radius: 10px;
}

@media screen and (max-width: 750px) {
  .DayOverallNum {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.DayOverallNum {
    width: 100% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/manager/components/DayOverallNum.vue